import React from 'react';
import BookList from '../book-list/book-list';

const HomePage = () => {
  return (
    <div className="shop">
      <BookList />
    </div>
  );
};

export default HomePage;